import React, { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { IoMdCheckmark } from "react-icons/io";
import IconButton from "@mui/material/IconButton";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { styled, useTheme } from "@mui/material/styles";
import deleteIcon from "../../components/assets/bin.svg";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import {
  Avatar,
  Box,
  Button,
  Divider,
  Grid,
  Popover,
  Typography,
} from "@mui/material";
import Select from "react-select";
// import Grid from "@mui/material/Grid2";
import LoadingSpinner from "../loader/LoadingSpinner";
import { deleteRequest, getRequest, patchRequest } from "../axiosClient";
import {
  DELETE_TASK_BY_ID,
  GET_SUB_TASK,
  GET_TASK,
  GET_TASK_BY_ID,
  GET_TASK_DOCUMENT,
  GET_TASKS,
  UPDATE_TASK,
} from "../utils";
import dayjs from "dayjs";
import {
  errorNotification,
  successNotification,
} from "../toast-notification/common-toast";
import validator from "validator";
import CommonDatePicker from "../../views/CommonDatePicker";
import { RxCross2 } from "react-icons/rx";
import { debounce } from "lodash";
import AddIcon from "@mui/icons-material/Add";
import Chat_tab_Section from "./Chat_tab_Section";
import TaskComments from "../../views/admin/taskDetails/TaskComments";
import Chat_UI from "../common/Chat_UI";
import secureLocalStorage from "react-secure-storage";
import CustomDrawer from "./CustomDrawer";
import Subtask_Section from "./Subtask_Section";
import Circle_Date_Component from "../common/Circle_Date_Component";
import { Padding } from "@mui/icons-material";

import high from "../../components/assets/high_priority.svg";
import low from "../../components/assets/low_priority.svg";
import normal from "../../components/assets/normal_priority.svg";
import { priorityOptions } from "../common/const";

const DrawerTaskDetail = ({ onClose, selectedTaskId }) => {
  const theme = useTheme();
  // const { id } = useParams();
  const titleRef = useRef();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [taskDetails, setTaskDetails] = useState({
    task_id: selectedTaskId,
  });
  const [updatedTaskDetails, setUpdatedTaskDetails] = useState({
    task_id: selectedTaskId,
  });
  const [dateValue, setDateValue] = useState(null);
  const [fileList, setFileList] = useState([]);
  const [memberList, setMemberList] = useState([]);
  const [statusOptionList, setStatusOptionList] = useState([]);
  const [taskType, setTaskType] = useState(null);
  const [showInput, setShowInput] = useState(false);
  const [value, setValue] = useState("");
  const hasMounted = useRef(false);
  const [subtask, setSubtask] = useState([]);

  const role_access =
    JSON.parse(secureLocalStorage.getItem("role_accesses")).find(
      (access) => access.module.name === "My Task"
    )?.access_type !== "Read";

  const [anchorEl, setAnchorEl] = React.useState(null);
  const customIcons = {
    Low: (
      <img
        src={low}
        alt="non urgent"
        style={{ width: "14px", height: "14px" }}
      />
    ),
    Medium: (
      <img
        src={normal}
        alt="important"
        style={{ width: "14px", height: "14px" }}
      />
    ),
    High: (
      <img src={high} alt="urgent" style={{ width: "14px", height: "14px" }} />
    ),
  };

  // const priorityOptionsList = ["non urgent", "important", "urgent"];
  const priorityOption = priorityOptions?.map((props) => ({
    label: props,
    value: props,
    icon: customIcons[props],
  }));

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  useEffect(() => {
    if (selectedTaskId) {
      getTaskDetails(selectedTaskId);
      // getTaskDocument();
      setUpdatedTaskDetails({
        task_id: selectedTaskId,
      });
    }
  }, [selectedTaskId]);

  const debouncedUpdateTask = debounce((prop) => {
    updateTaskDetails(prop);
    // getTaskDetails(selectedTaskId);
  }, 100);

  const previousTaskDetails = useRef(taskDetails);
  const previousUpdatedTaskDetails = useRef(updatedTaskDetails);

  useEffect(() => {
    if (!hasMounted.current) {
      hasMounted.current = true;
      return;
    }

    // Check if both taskDetails and updatedTaskDetails have changed
    const taskDetailsChanged = previousTaskDetails.current !== taskDetails;
    const updatedTaskDetailsChanged =
      previousUpdatedTaskDetails.current !== updatedTaskDetails;

    if (taskDetailsChanged && updatedTaskDetailsChanged) {
      if (!role_access) {
        return;
      }
      debouncedUpdateTask(updatedTaskDetails);
    }

    // Update refs to current values
    previousTaskDetails.current = taskDetails;
    previousUpdatedTaskDetails.current = updatedTaskDetails;

    return () => {
      debouncedUpdateTask.cancel();
    };
  }, [taskDetails, updatedTaskDetails]);

  const getTaskDetails = async (taskid) => {
    setLoading(true);
    try {
      const res = await getRequest(
        `${GET_TASK}?task_id=${taskid}`,
        null,
        navigate
      );
      if (res.data && res.data.data) {
        setDateValue(
          res.data.data?.taskData.due_date
            ? res.data.data?.taskData.due_date
            : null
        );
        setTaskDetails((prevTaskDetails) => ({
          ...prevTaskDetails,
          ...res.data.data.taskData,
        }));
        // setMemberList(res.data.data?.assignedToUsers);

        let dataList;
        dataList = res.data.data?.assignedToUsers?.map((item) => {
          return {
            value: item?.id,
            label:
              item?.first_name || item?.last_name
                ? item?.first_name + " " + item?.last_name
                : item?.name,
            profile_image: item?.profile_image,
          };
        });

        // * To add option for none option in project and project lead task * //

        if (
          res.data.data?.taskData.task_type === "Project" ||
          res.data.data?.taskData.task_type === "Project Lead"
        ) {
          dataList.unshift({ value: null, label: "None", profile_image: null });
        }
        setMemberList(dataList);
        setStatusOptionList(res.data.data?.taskStatus);
        setTaskType(res.data.data?.taskData.task_type);
        setSubtask(res.data.data?.taskData?.sub_tasks);
      } else {
        errorNotification(res.errormessage);
        navigate(-1);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
      errorNotification(error);
    } finally {
      setLoading(false);
    }
  };

  // const getTaskDocument = async () => {
  //   try {
  //     setLoading(true);
  //     const res = await getRequest(
  //       `${GET_TASK_DOCUMENT}?task_id=${id}`,
  //       null,
  //       navigate
  //     );
  //     if (res.data && res.data.data) {
  //       setFileList(res.data.data);
  //     } else {
  //       setFileList([]);
  //       errorNotification(res.errormessage);
  //     }
  //     setLoading(false);
  //   } catch (error) {
  //     errorNotification(error);
  //     setLoading(false);
  //   }
  // };

  const updateTaskDetails = async (payload) => {
    // console.log(payload);
    //Don't make API call when still focus is true
    if (titleRef.current && document.activeElement === titleRef.current) {
      return;
    } else {
      previousTaskDetails.current = taskDetails;
      previousUpdatedTaskDetails.current = updatedTaskDetails;
    }

    if (payload?.title !== undefined && validator.isEmpty(payload.title)) {
      console.log("Test");
      getTaskDetails(selectedTaskId);
      setUpdatedTaskDetails({
        task_id: selectedTaskId,
      });
      errorNotification("Task title can not be empty");
      return;
    }
    const updatedPayload = { ...payload };

    if (payload?.due_date !== undefined) {
      updatedPayload.due_date =
        typeof payload.due_date === "string" && payload.due_date.trim() === ""
          ? null
          : payload.due_date;
    }

    try {
      const res = await patchRequest(
        `${UPDATE_TASK}`,
        updatedPayload,
        navigate
      );
      if (res?.response && res?.response.data.success) {
        // console.log(taskDetails);
        // console.log(updatedTaskDetails);
        getTaskDetails(selectedTaskId);
        // console.log("task Updated", res?.response);
      } else {
        errorNotification(res?.errormessage);
      }
      setUpdatedTaskDetails({
        task_id: selectedTaskId,
      });
    } catch (error) {
      getTaskDetails();
      console.error(error);
      errorNotification(error);
    } finally {
      setLoading(false);
    }
  };

  const handleDateChange = (newValue, formattedDate) => {
    const value = newValue ? dayjs(newValue).format("YYYY-MM-DD") : null;
    setDateValue(value);
    setTaskDetails((prevDetails) => ({
      ...prevDetails,
      due_date: value,
    }));
    setUpdatedTaskDetails((prevUpdatedDetails) => ({
      ...prevUpdatedDetails,
      due_date: value,
    }));
  };

  const handleTagRemove = (index) => {
    let array = [...taskDetails.tags];
    array.splice(index, 1);
    setTaskDetails({ ...taskDetails, tags: array });
    setUpdatedTaskDetails({ ...updatedTaskDetails, tags: array });
  };

  const handleAssigneRemove = (id) => {
    console.log("assigne remove", id);
    setTaskDetails({ ...taskDetails, assigned_to: null });
    setUpdatedTaskDetails({
      ...updateTaskDetails,
      task_id: `${id}`,
      assigned_to: null,
    });
  };

  const statusOption = statusOptionList?.map((props) => ({
    label: props?.title,
    value: props?.id,
  }));

  const handleAddTag = () => {
    setShowInput(true);
    setValue("");
  };

  const handleChange = (e) => {
    setValue(e.target.value);
  };

  const handleBlur = () => {
    if (value.length >= 2) {
      submitValue();
    } else {
      setValue("");
      setShowInput(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault(); // Prevents default behavior (like form submission)
      if (value.length > 2) {
        submitValue();
      }
    }
  };

  const submitValue = () => {
    // Create a new array with the current tags plus the new value
    let updatedArray = [...(taskDetails.tags || []), value];

    // Update both states with the new array
    setUpdatedTaskDetails((prevState) => ({
      ...prevState,
      tags: updatedArray,
    }));

    setTaskDetails((prevState) => ({
      ...prevState,
      tags: updatedArray,
    }));
    setShowInput(false);
    // Clear the input value
    setValue("");
  };

  const handleDescriptionChange = (e, id) => {
    const value = e?.target?.value;
    console.log(value);
    setTaskDetails({
      ...taskDetails,
      // task_id: id,
      description: value,
    });
    setUpdatedTaskDetails({
      ...updatedTaskDetails,
      task_id: id,
      description: value,
    });
  };

  const debouncedResults = useMemo(() => {
    return debounce(handleDescriptionChange, 500);
  }, []);

  useEffect(() => {
    return () => {
      debouncedResults.cancel();
    };
  });

  const handleSubtaskClick = () => {
    if (subtask?.[subtask.length - 1]?.id || subtask.length < 1) {
      setSubtask([
        ...subtask,
        { title: "", due_date: null, is_completed: false },
      ]);
    }
  };

  const handleTaskDelete = async (id) => {
    try {
      if (!id) {
        return;
      }
      let apiUrl = `${DELETE_TASK_BY_ID}?task_id=${id}`;
      const res = await deleteRequest(apiUrl, null, navigate);
      if (res?.type === 1) {
        // navigate(-1);
        onClose();
        successNotification(res.response.data.message);
      } else {
        errorNotification(res.errormessage);
      }
    } catch (error) {
      console.error("error", error);
    }
  };

  return loading ? (
    <LoadingSpinner />
  ) : (
    <div className="flex flex-col min-h-screen w-[70]">
      <div className="flex justify-between m-1">
        <button
          className={`border cursor-pointer m-1 p-0.5 rounded text-xs ${
            taskDetails.is_completed ? "bg-[#dcf7d9]" : ""
          } hover:bg-[#dcf7d9] hover:border-green-500`}
          onClick={(e) => {
            const change = taskDetails.is_completed ? false : true;
            setTaskDetails({
              ...taskDetails,
              is_completed: change,
            });
            setUpdatedTaskDetails({
              ...updatedTaskDetails,
              is_completed: change,
            });
          }}
        >
          <span className="flex flex-row items-center gap-1">
            {<IoMdCheckmark />}
            {!taskDetails.is_completed ? "Mark complete" : "Completed"}
          </span>
        </button>

        <div>
          <IconButton onClick={onClose}>
            <ChevronRightIcon />
          </IconButton>
          <button
            aria-describedby={id}
            variant="contained"
            onClick={handleClick}
          >
            <MoreVertIcon />
          </button>
          <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
          >
            <div className="w-[170px] min-w-[170px] py-1 bg-[#FFFFFF]">
              <div
                className="flex px-[14px] py-2 hover:bg-[#F8F8F8] cursor-pointer items-center"
                onClick={(e) => {
                  handleTaskDelete(selectedTaskId);
                  handleClose();
                }}
              >
                <img
                  src={deleteIcon}
                  alt="delete"
                  className="mr-[14px] h-4 w-4"
                />
                <p className="font-medium text-[#3C556B] text-[14px] align-middle">
                  Delete
                </p>
              </div>
            </div>
          </Popover>
        </div>
      </div>
      <Divider />
      <div className="p-2 flex-1 overflow-auto">
        <div className="border border-[#cfcbcb] w-full p-2 rounded-md flex flex-col gap-2">
          {/* Title */}
          <div>
            <input
              type="text"
              ref={titleRef}
              placeholder="Enter title of task"
              className="focus:border-2 border-[#cfcbcb] w-full rounded-md p-2 font-medium text-md"
              value={taskDetails.title}
              onChange={(e) => {
                setTaskDetails({ ...taskDetails, title: e.target.value });
                setUpdatedTaskDetails({
                  ...updatedTaskDetails,
                  title: e.target.value,
                });
              }}
              onBlur={() => updateTaskDetails(updatedTaskDetails)}
            />
          </div>

          {/* Layout: Assignee + DueDate | Status + Tags | Priority | Description */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full">
            {/* LEFT HALF */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
              {/* Assignee */}
              <div>
                <span className="text-xs text-black">Assignee:</span>
                <div className="flex items-center">
                  {taskDetails?.assigned_to === null ? (
                    <Select
                      className="text-sm w-full"
                      styles={{
                        control: (base) => ({
                          ...base,
                          backgroundColor: "transparent",
                          border: "1px solid #ccc",
                          borderRadius: "0.375rem",
                          boxShadow: "none",
                        }),
                        indicatorSeparator: () => ({ display: "none" }),
                      }}
                      classNamePrefix="select"
                      options={memberList}
                      isSearchable
                      value={memberList.find(
                        (option) => option.value === taskDetails.assigned_to
                      )}
                      onChange={(selected) => {
                        setTaskDetails({
                          ...taskDetails,
                          assigned_to: selected?.value ?? null,
                        });
                        setUpdatedTaskDetails({
                          ...updatedTaskDetails,
                          assigned_to: selected?.value ?? null,
                        });
                      }}
                    />
                  ) : (
                    <>
                      <div className="flex items-center hover:bg-slate-100 rounded-md p-1">
                        <Avatar
                          sx={{
                            bgcolor: "orange",
                            width: 24,
                            height: 24,
                            fontSize: "1rem",
                          }}
                        >
                          {taskDetails?.assignee?.first_name?.[0]}
                        </Avatar>
                        <span className="text-sm p-2">
                          {taskDetails?.assignee?.first_name}
                        </span>
                      </div>
                      <span
                        className="ml-1 cursor-pointer hover:bg-slate-100 p-2 rounded-md"
                        onClick={() => handleAssigneRemove(selectedTaskId)}
                      >
                        <RxCross2 />
                      </span>
                    </>
                  )}
                </div>
              </div>

              {/* Due Date */}
              <div>
                <span className="text-xs text-black mb-1">Due Date:</span>
                <div
                  className="h-[38px] px-3 rounded-md flex items-center hover:bg-slate-100"
                  style={{ border: "1px solid #ccc" }}
                >
                  <Circle_Date_Component
                    value={dayjs(dateValue) || ""}
                    onChange={handleDateChange}
                  />
                </div>
              </div>

              {/* Description (full width) */}
              

              {/* Status */}
              <div>
                <span className="text-xs text-black">Status:</span>
                <Select
                  className="text-sm w-full"
                  styles={{
                    control: (base) => ({
                      ...base,
                      backgroundColor: "transparent",
                      border: "1px solid #ccc",
                      borderRadius: "0.375rem",
                      boxShadow: "none",
                    }),
                    indicatorSeparator: () => ({ display: "none" }),
                  }}
                  classNamePrefix="select"
                  placeholder="Status"
                  options={statusOption}
                  value={statusOption.find(
                    (option) => option.value === taskDetails?.task_status?.id
                  )}
                  onChange={(e) => {
                    setTaskDetails({
                      ...taskDetails,
                      task_status: { id: e.value },
                    });
                    setUpdatedTaskDetails({
                      ...updatedTaskDetails,
                      status_id: e.value,
                    });
                  }}
                />
              </div>

              {/* Priority */}
              <div>
                <span className="text-xs text-black">Priority:</span>
                <Select
                  className="text-sm w-full"
                  styles={{
                    control: (base) => ({
                      ...base,
                      backgroundColor: "transparent",
                      border: "1px solid #ccc",
                      borderRadius: "0.375rem",
                      boxShadow: "none",
                    }),
                    indicatorSeparator: () => ({ display: "none" }),
                  }}
                  classNamePrefix="select"
                  placeholder="Priority"
                  options={priorityOption}
                  value={
                    taskDetails?.priority
                      ? {
                          label: taskDetails.priority,
                          value: taskDetails.priority,
                          icon: customIcons[taskDetails.priority],
                        }
                      : null
                  }
                  onChange={(e) => {
                    setTaskDetails({ ...taskDetails, priority: e?.value });
                    setUpdatedTaskDetails({
                      ...updatedTaskDetails,
                      priority: e?.value,
                    });
                  }}
                />
              </div>

              {/* Tags (full width) */}
              <div className="col-span-2">
                <span className="text-xs text-black mb-1">Tags:</span>
                <div className="flex flex-wrap gap-2 w-full border border-gray-300 rounded-md p-2">
                  {taskDetails.tags?.map((tag, index) => (
                    <span
                      key={index}
                      className="flex items-center text-sm max-h-6 p-2 bg-green-200 text-green-700 rounded"
                    >
                      {tag.length > 10 ? `${tag.slice(0, 10)}...` : tag}
                      <span
                        className="ml-1 cursor-pointer"
                        onClick={() => handleTagRemove(index)}
                      >
                        <RxCross2 />
                      </span>
                    </span>
                  ))}
                  {showInput ? (
                    <input
                      className="p-2 border border-gray-300 rounded-md max-w-[80px]"
                      value={value}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      onKeyDown={handleKeyDown}
                      autoFocus
                    />
                  ) : (
                    <button
                      className="text-xs text-slate-500 hover:bg-slate-100 p-1 rounded-md"
                      onClick={handleAddTag}
                    >
                      Add Tag
                    </button>
                  )}
                </div>
              </div>
<div className="col-span-3">
                <span className="text-xs text-black">Description:</span>
                <textarea
                  name="description"
                  className="w-full min-h-[10rem] max-h-[15rem] rounded-md p-2 bg-transparent placeholder:text-xs"
                  style={{ border: "1px solid #ccc" }}
                  defaultValue={taskDetails.description || ""}
                  placeholder="What is this task about?"
                  onChange={(e) => debouncedResults(e, selectedTaskId)}
                />
              </div>
            </div>

            {/* RIGHT HALF - Subtasks */}
            <div className="flex flex-col h-full">
              <span className="text-xs font-semibold text-black border-b border-gray-300 pb-1">
                Subtasks:
              </span>
              {subtask.map((elem, index) => (
                <Subtask_Section
                  key={index}
                  index={index}
                  subtask={subtask}
                  setSubtask={setSubtask}
                  assignee={taskDetails.assignee}
                  role_access={role_access}
                  selectedTaskId={selectedTaskId}
                  statusOption={statusOption}
                  getTask={getTaskDetails}
                />
              ))}
              <button
                className="border border-slate-400 p-1 rounded-md text-xs flex items-center gap-1 w-fit mt-1"
                onClick={handleSubtaskClick}
              >
                <AddIcon className="text-slate-600" fontSize="1rem" />
                Add subtask
              </button>
            </div>
          </div>

          {/* Subtasks */}
        </div>
      </div>

      <div style={{ background: "#f9f8f8" }}>
        <Chat_tab_Section selectedTaskId={selectedTaskId} />
      </div>
      {/* <div>
        <footer className="p-3"></footer>
      </div> */}
    </div>
  );
};

export default DrawerTaskDetail;
